<template>
  <v-dialog v-model="dialog" persistent width="1000">
    <v-card v-show="!loading">
      <v-toolbar flat dense elevation="1" class="mb-1">
        <v-toolbar-title :class="$vuetify.breakpoint.mobile ? 'toolbar-title-mobile' : ''">
          <span class="font-weight-medium">Cronograma dos Editais</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text fab small @click="fechar">
          <v-icon dark>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row class="fill-width">
          <v-col>
            <v-toolbar flat dense class="mb-n2">

              <v-btn text fab small @click="prev">
                <v-icon>
                  mdi-chevron-left
                </v-icon>
              </v-btn>
              <v-spacer></v-spacer>

              <v-toolbar-title :class="$vuetify.breakpoint.mobile ? 'toolbar-title-mobile' : ''">
                {{ month }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn text fab small @click="next">
                <v-icon>
                  mdi-chevron-right
                </v-icon>
              </v-btn>
            </v-toolbar>
          </v-col>
        </v-row>

        <v-row class="fill-height">
          <v-col>
            <v-sheet height="600">
              <v-calendar ref="calendar" color="primary" v-model="value" :type="type" :events="events"
                :event-color="getEventColor" :weekdays="weekday" :event-more="false"
                @click:event="showEvent"></v-calendar>

              <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" :position-x="x"
                :position-y="y" absolute offset-x max-width="250px">
                <v-card color="grey lighten-4" flat>
                  <v-toolbar dense flat :color="selectedEvent.color" dark>
                    <v-toolbar-title class="text-subtitle-2">{{ selectedEvent.edital }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn text fab small @click="selectedOpen = false">
                      <v-icon dark>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text class="text-caption">
                    <p><strong>Edital:</strong> {{ selectedEvent.edital }}</p>
                    <p><strong>Etapa:</strong> {{ selectedEvent.name }}</p>
                    <p><strong>Início:</strong> {{ $toBrDate(selectedEvent.start) }}</p>
                    <p><strong>Fim:</strong> {{ $toBrDate(selectedEvent.end) }}</p>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-sheet>
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>
    <LoadingDialog :loading="loading" />
  </v-dialog>
</template>

<script>
import {app} from "../services/feathers";
import LoadingDialog from "@/components/LoadingDialog.vue"

export default {
  metaInfo: {
    title: "UNIFAP",
    // all titles will be injected into this template
    titleTemplate: "%s - DEPSEC",
  },
  name: "App",
  props: ["dialog"],
  components: { LoadingDialog },
  data() {
    return {
      x: 0,
      y: 0,
      loading: false,
      month: "",
      editais: [],
      value: '',
      type: 'month',
      mode: 'column',
      weekday: [0, 1, 2, 3, 4, 5, 6],
      events: [],
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1', 'pink', 'purple'],
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
    }
  },
  async created() {
    this.loading = true;
    this.carregar();
    this.loading = false;
  },
  updated() {
    this.month = this.$refs.calendar ? this.$refs.calendar.title : "";
  },
  methods: {
    fechar() {
      this.$emit("close");
    },
    showEvent({ nativeEvent, event }) {
      nativeEvent.preventDefault();
      this.selectedOpen = false;

      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        this.x = nativeEvent.clientX;
        this.y = nativeEvent.clientY;
        requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true));
      }

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    async carregar() {
      try {
        this.editais = await app.service("selective-processes").find({
          query: {
            $or: [{ closed: { $in: false } }, { closed: { $nin: true } }],
            $sort: {
              createdAt: -1,
            },
          },
        });
        for (var e of this.editais) {
          e.cor = this.colors[this.rnd(0, this.colors.length - 1)];
        }
        this.montaEventos();
      } catch (error) {
        console.log(error);
      }
    },

    async montaEventos() {
      const events = [];
      for (var e of this.editais) {
        for (var c of e.schedule) {
          events.push({
            edital: e.title,
            name: c.title,
            start: new Date(c.start),
            end: new Date(c.end),
            color: e.cor,
            timed: false,
          })
        }
      }
      this.events = events;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },

    getEventColor(event) {
      return event.color;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
  }
}
</script>
<style></style>